import { PostEditorReducerFunction, PostEditorSetPostTimingAction } from '../PostEditorActions';
import { OnStateUpdateCallbackFunction, postGroupStateUpdater } from '../../helpers/postGroupStateUpdater';
import { PostStatus, PostTiming } from '../../../../models/graphql';
import { ImmutabilityContext } from '../effects/customImmutabilityContext';
import { validatorStateUpdater } from '../../validators/helpers/validatorStateUpdater';
import { ErrorMessageSeverity } from '../../../../constants/form';

export const setPostTimingReducer: PostEditorReducerFunction<PostEditorSetPostTimingAction['payload']> = (
  state,
  payload
) => {
  const { customizeIndex, postGroupIndex, postTiming, defaultQueuePosition } = payload;
  const callback: OnStateUpdateCallbackFunction = currentPost => {
    const { update: updateImmutable } = ImmutabilityContext;
    const currentPostStatus = currentPost.postStatus;
    const newPostTiming =
      currentPostStatus === PostStatus.DRAFT && postTiming === PostTiming.NOW ? PostTiming.SCHEDULE : postTiming;
    const currentQueuePosition = currentPost.scheduling.queuePosition;
    const queuePosition =
      newPostTiming === PostTiming.QUEUE && currentQueuePosition === null && defaultQueuePosition
        ? defaultQueuePosition
        : currentQueuePosition;
    return updateImmutable(currentPost, {
      scheduling: {
        postTiming: {
          $set: newPostTiming
        },
        queuePosition: {
          $set: queuePosition
        },
        recurring: {
          active: { $set: postTiming === PostTiming.RECURRING }
        }
      }
    });
  };
  const result = postGroupStateUpdater(state, postGroupIndex, customizeIndex, 'schedule', callback);
  return validatorStateUpdater(result, postGroupIndex, ErrorMessageSeverity.warning, [
    'checkDateAndTime',
    'checkExpiryCount',
    'checkExpiryDate',
    'checkRecurringInterval',
    'checkQueuePosition',
    'expireCountRequired',
    'expireDateRequired',
    'pinterestDuplicatesCheck',
    'preventTwDuplicate',
    'preventPostNowForDisconnected',
    'profileRequired',
    'scheduleTextOrMediaVariations',
    'videoNotTranscoded'
  ]);
};
